import React, { useEffect } from "react";
import { useForm } from "react-final-form";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "src/constants/StringConstants";
import NumberField from "../../../../../components/Form/NumberFormatFieldV2/NumberFormatFieldV2";

const PremiumForm = ({ premiumMode = [], policyTerm = [] }) => {
  const form = useForm();
  const mode = form.getFieldState("mode")?.value;
  const modalPremium = form.getFieldState("modalPremium")?.value;

  const multipliers = { "1": 1, A: 1, M: 12, Q: 4, SA: 2 };

  useEffect(() => {
    const annualizedPremium = modalPremium * multipliers[mode];
    if (!isNaN(annualizedPremium)) {
      form.change("annualizedPremium", annualizedPremium);
    }
  }, [modalPremium, mode]);

  return (
    <Col sm="5">
      <Row>
        <Col sm="10" className="app-form-header">
          <h4 className="form-title">{S.APP_PREMIUM_DETAIL_TITLE}</h4>
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <TypeaheadField name="mode" label={S.APP_FIELD_PREMIUM_MODE_LABEL} options={premiumMode} />
        </Col>
        <Col sm="5">
          <TypeaheadField name="policyTerm" label={S.APP_FIELD_POLICY_TERM_LABEL} options={policyTerm} />
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <NumberField
            name="modalPremium"
            label={S.APP_FIELD_MODAL_PREMIUM_LABEL}
            prefix="$"
            thousandSeparator={true}
            decimalScale={2}
          />
        </Col>
        <Col sm="5">
          <TextField name="tableRatingPercentage" label={S.APP_FIELD_TABLE_RATING_LABEL} />
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <NumberField
            name="annualPremium"
            label={S.APP_FIELD_ANNUAL_PREMIUM_LABEL}
            prefix="$"
            thousandSeparator={true}
            decimalScale={2}
          />
        </Col>
        <Col sm="5">
          <NumberField
            name="cashWithAppAmount"
            label={S.APP_FIELD_APP_AMOUNT_LABEL}
            prefix="$"
            thousandSeparator={true}
            decimalScale={2}
          />
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <NumberField
            name="annualizedPremium"
            label={S.APP_FIELD_ANNUALIZED_PREMIUM_LABEL}
            prefix="$"
            thousandSeparator={true}
            decimalScale={2}
            readonly
          />
        </Col>
        <Col sm="5" style={{ textAlign: "left", display: "flex", flexDirection: "column", alignItems: "baseline" }}>
          <CheckboxField name="smoker" label={S.APP_FIELD_SMOKER_LABEL} labelPosition="above" />
        </Col>
      </Row>

      <Row>
        <Col sm="10">
          <TextField name="notes" label={S.APP_FIELD_FIRST_NOTES_LABEL} multiline />
        </Col>
      </Row>
    </Col>
  );
};

export default PremiumForm;
